import { render, staticRenderFns } from "./OrganismCredential.vue?vue&type=template&id=0947fc5e&scoped=true&"
import script from "./OrganismCredential.vue?vue&type=script&lang=js&"
export * from "./OrganismCredential.vue?vue&type=script&lang=js&"
import style0 from "./OrganismCredential.vue?vue&type=style&index=0&id=0947fc5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0947fc5e",
  null
  
)

export default component.exports